module.exports = __webpack_public_path__ + "static/media/veneto-3-12.5ad9b1df.jpg";